import React, { useEffect, createElement } from 'react';
import { VSLSection } from '../components/VSLSection';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function VSLPage() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.fbq) {
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1428740802233981');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = 'https://www.facebook.com/tr?id=1428740802233981&ev=ViewContent&noscript=1';
        noscript.appendChild(img);
        document.head.appendChild(noscript);
      }
      window.fbq('track', 'ViewContent');
    }
  }, []);
  return <main className="min-h-screen bg-navy font-sans text-cream selection:bg-terracotta/30 selection:text-navy" data-id="element-267">
      <VSLSection data-id="element-268" />
    </main>;
}